import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatDate, isOverdue } from '@platform/core/lib/format';
import { routes } from '@platform/core/lib/routes';
import { recordCode } from '../form/header/recordCode';
import { statusColor } from '@platform/core/lib/statusColors';
import type { IUserRef } from '@platform/core/types';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { isDoneStatus } from '@platform/engine/views/doneStatuses';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import type { IChildRecordRowProps } from './IChildRecordRowProps';

/**
 * Рядок дочірнього запису (прототип v4, «Дочірні завдання»): номер 70px (mono, без префікса типу) · назва (відкриває запис) · статус із крапкою · виконавець ·
 * термін (прострочений — червоний; завершений за списком DONE прототипу — ні) · «N год» залишилось · × «Вилучити з батьківського» (лише розриває ієрархію, запис лишається).
 */
export function ChildRecordRow({ moduleKey, rt, child, canEdit, onRemove }: IChildRecordRowProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const lang = useAppSelector(selectLang);
  const assignee = child.values['assignee'] as IUserRef | null | undefined;
  const due = typeof child.values['due'] === 'string' ? (child.values['due'] as string) : '';
  const remaining = child.values['remaining'];
  return (
    <div className="rtab-child">
      <span className="rtab-child__code" title={child.display}>{recordCode(child.display, child.code)}</span>
      <Link className="rtab-child__title" to={routes.record(moduleKey, rt.key, child.id)} title={child.title}>{child.title}</Link>
      <span className="rtab-child__status"><span className="dot" style={{ background: statusColor(rt.statuses, child.status, rt.key) }} />{strings.status(rt.key, child.status, child.status)}</span>
      <span className="rtab-child__who" title={assignee?.name}>{assignee?.name ?? '—'}</span>
      <span className={isOverdue(due || null, isDoneStatus(child.status)) ? 'rtab-child__due is-late' : 'rtab-child__due'}>{formatDate(due, lang)}</span>
      <span className="rtab-child__rem">{remaining !== null && remaining !== undefined && remaining !== '' ? t('recordPage.children.hours', { count: Number(remaining) }) : ''}</span>
      {canEdit
        ? <button type="button" className="rtab-x" title={t('recordPage.children.remove')} aria-label={t('recordPage.children.remove')} onClick={() => onRemove(child)}>×</button>
        : <span />}
    </div>
  );
}
